<template>
    <div class="main-form monthly-summary">
        <h1 class="header-title">Monthly RAMS SKILLS Summary</h1>
        <div>
            <p>
                This report shows a summary of rams and skills for the selected month and year.
            </p>

            <control-select label="Year" :options="years" v-model="year"></control-select>
            <control-select label="Month" :options="months" v-model="month"></control-select>
        </div>
        <div v-show="showErrors && missingDate" class="error">Year and Month fields are mandatory.</div>
        <div v-show="showErrors && dateInFuture" class="error" >The date can't be in future.</div>
        <div class="buttons">
            <button type="button" class="btn btn-primary btn-sm" @click="download">Download</button>
        </div>
    </div>
</template>

<script>

    import { DateTime, Info } from "luxon";

    export default {
        data() {
            return {
                today: null,
                years: [],
                months: [],
                year: null,
                month: null,
                showErrors: false
            }
        },
        async created() {
            this.months = Info.months('long', { locale: 'en' }).map((x, i) => { return { value: i + 1, text: x }; });
            this.months.unshift({ value: 0, text: 'All months' });
            this.today = DateTime.now();
            var lastMonth = this.today.minus({ months: 1 });
            this.year = lastMonth.year;
            this.month = lastMonth.month;
            for (var i = 2020; i <= this.today.year; i++)
                this.years.push(i);
            
        },
        computed: {
            missingDate() {
                return (!this.year || !(this.month >= 0));
            },
            dateInFuture() {
                return (!this.missingDate && (this.year > this.today.year || (this.year == this.today.year && this.month > this.today.month)));
            }
        },
        methods: {
            download() {
                this.showErrors = true;
                if (!this.missingDate && !this.dateInFuture) {
                   this.$store.dispatch('adminReports/getMonthlySummaryReport', { download: true, year: this.year, month: this.month });
                }
            },
        }
    }
</script>

<style>
    .monthly-summary .control-text {
        display: inline-block;
    }

    .monthly-summary .control-text input {
        font-size: small;
        width: 3rem;
        padding: 0 2px 0 8px;
        height: 1.5rem;
    }

</style>
